import { Component, OnInit ,Output, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding, ViewChild,ChangeDetectorRef,ChangeDetectionStrategy } from '@angular/core';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'vg-social-icons',
    encapsulation: ViewEncapsulation.None,
    template: `
    <div class="title-container" [ngClass]="{'hidden': hidden}"> 
        <social-icons [isShare]="true" class="video" [item]="meta"  [titlebar]="true"></social-icons>
        <a href="{{link}}" target="_blank" class="title">{{meta.title}}</a>
        <a class="top-logo-container pull-right" href="{{link}}" target="_blank">
            <img class="img-responsive chickasaw-mobile-logo" src="/images/CTV_LOGO.png" />
        </a>
    </div>
    `,

    styleUrls: ['./vg-social-icons.styles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})



export class VgSocialIcons implements OnDestroy {
    @Input() item : any;
    @Input() hidden: boolean;
    @Input() media: any;
    @Input() meta: any;
    @Input() logo: string;
    @Input() link: string;
    subscriptions: Array<any> = [];
    
    constructor(private controlsHidden: VgControlsHidden, private api: VgAPI ) {
        
    }
   
    //@Output from vg-player component
   
    ngOnInit() {
        if (this.api.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.api.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }
   onPlayerReady(){
       this.subscriptions.push(this.controlsHidden.isHidden.subscribe( this.onHideControls.bind(this)));
   }
   
   onHideControls(state:boolean) {
       this.hidden  = state;
   }

   ngOnDestroy(){
    this.subscriptions.forEach(s => s.unsubscribe());
   }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-social-icons.component.ts